export const organizationGermanLocalization = {
  'organization-detail': {
    sections: {
      activities: 'Aktivitäten',
      management: 'Verwaltung',
      area: 'Gebiet'
    },
    rows: {
      allFunks: 'Alle Funks',
      mentioned: 'Mitgefunkt',
      members: 'Mitglieder',
      statisticsMail: 'Statistiken per E-Mail',
      organizations: 'Organisationen'
    },
    edit: 'Organisation bearbeiten',
    state: {
      loading: { title: 'Organisation wird geladen' },
      error: {
        title: 'Organisation konnte nicht geladen werden',
        subtitle: 'Bitte versuche es später erneut.'
      },
      noAccess: {
        title: 'Kein Zugriff',
        subtitle: 'Du hast keine Berechtigung, diese Organisation anzusehen.'
      }
    }
  },
  organization: {
    tagLabels: {
      EMERGENCY_AID: 'Blaulicht',
      VOLUNTEERING: 'Ehrenamt',
      CIVIL_PROTECTION: 'Katastrophenschutz',
      ENTERTAINMENT: 'Unterhaltung',
      PARTNER: 'Partner',
      ADMIN: 'Verwaltung',
      TERRITORIAL_AUTHORITY: 'Kommunal',
      CLUB: 'Verein',
      EDUCATION: 'Bildung',
      RELIGION: 'Religion',
      MINISTRY: 'Ministerium'
    },
    roleLabels: {
      ADMIN: 'Chef Funker',
      FUNKER: 'Funker'
    },
    globalRoleLabels: {
      SUPER_ADMIN: 'Super-Admin',
      GLOBAL_CONFIGURATION_ADMIN: 'Konfigurations-Admin',
      ORGANIZATION_CONFIGURATION_ADMIN: 'Organisations-Admin'
    }
  }
};

export const organizationEnglishLocalization = {
  'organization-detail': {
    sections: {
      activities: 'Activities',
      management: 'Management',
      area: 'In Area'
    },
    rows: {
      allFunks: 'All posts',
      mentioned: 'Mentioned',
      members: 'Members',
      statisticsMail: 'Statistics via email',
      organizations: 'Organizations'
    },
    edit: 'Edit organization',
    state: {
      loading: { title: 'Loading organization' },
      error: {
        title: 'Could not load organization',
        subtitle: 'Please try again later.'
      },
      noAccess: {
        title: 'No access',
        subtitle: 'You do not have permission to view this organization.'
      }
    }
  },
  organization: {
    tagLabels: {
      EMERGENCY_AID: 'Public Safety',
      VOLUNTEERING: 'Volunteer organizations',
      CIVIL_PROTECTION: 'Civil protection',
      ENTERTAINMENT: 'Entertainment',
      PARTNER: 'Partner',
      ADMIN: 'Administration',
      TERRITORIAL_AUTHORITY: 'Territorial authorities',
      CLUB: 'Clubs',
      EDUCATION: 'Educational institutions',
      RELIGION: 'Religious communities',
      MINISTRY: 'Ministries'
    },
    roleLabels: {
      ADMIN: 'Chief Funker',
      FUNKER: 'Funker'
    },
    globalRoleLabels: {
      SUPER_ADMIN: 'Super Admin',
      GLOBAL_CONFIGURATION_ADMIN: 'Config Admin',
      ORGANIZATION_CONFIGURATION_ADMIN: 'Organization Admin'
    }
  }
};
